export default __webpack_public_path__ + "static/media/YAS0520.34I-27816_-16713_100.c8ff98d2.jpg";